import React, { ComponentProps } from 'react';
import { ProfileImage } from '../../../types/api/ImageType';
import IForm from '../../../types/IForm';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';
import { Hint } from '../../../_lib/components/Hint';

type PortalAvatarEditProps = {
  image: ProfileImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: IForm;
};

export function PortalAvatarEdit({ image, form, cropping, viewportSwitch }: PortalAvatarEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('PortalAvatar');

  return (
    <>
      <div className="portal-avatar">
        <Hint message={t('faviconMessage')} />
        <p className="portal-avatar__additional-message">{t('additionalMessage')}</p>
      </div>
      <ImageUploadForm
        imageDescriptionName={t('imageDescriptionName')}
        cropping={cropping}
        viewportSwitch={viewportSwitch}
        form={form}
        formId="portal-avatar-image-upload-form"
        uuid={uuid}
        initialImage={image}
        refresh={refresh}
      />
    </>
  );
}

export const PortalAvatarEditView = asFetchableView(PortalAvatarEdit);
export type PortalAvatarEditView = ComponentProps<typeof PortalAvatarEditView>;
